import { AboutStyle } from "./../styles/About";

function Home() {
    return (
        <div className="About">
            <AboutStyle/>
            <h1>Over mij</h1>
            <p>Mijn naam is Gideon Noya. Oprichter van Eagle Studios. Mijn hobby is om video's te maken met mijn FPV drone.</p>
            <p>Omdat dit mijn hobby is, vraag ik momenteel geen geld voor het maken van video's.</p>
            <p>Voor nu ben ik gefocust op het professionaliseren van mijn drone vaardigheden en het creëren van contacten en een portfolio.</p>
            <br></br>
            <h1>Wat kan ik filmen?</h1>
            <p>- Snel bewegende objecten zoals attracties, voertuigen, etc. </p>
            <p>- Panden (binnen en buiten) </p>
            <p>- Shows/evenementen </p>
            <br></br>
            <h1>Contact gegevens</h1>
            <p>Wilt u ook een FPV drone video van uw bedrijf? Stuur dan een mail naar eaglestudiosfpv@gmail.com </p>
            <br></br>
            <hr></hr>
        </div>
    );
}

export default Home;